export default __webpack_public_path__ + "static/media/luncheon.8431a3a1.jpg";